/**
 * Presentational styles for Veersa Points dashboard (from VeersaDashboard.jsx sample).
 */

export const veersaPointsDashboardStyles = {
  wrapper: {
    fontFamily: "'DM Sans', 'Segoe UI', system-ui, sans-serif",
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 16,
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    margin: 0,
    overflow: "hidden",
  },
  header: {
    padding: "1.5rem 1.5rem 1rem",
    borderBottom: "0.5px solid #e5e7eb",
  },
  headerTopRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    width: "100%",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    flex: "1 1 auto",
    minWidth: 0,
  },
  greeting: { fontSize: 13, color: "#6b7280", marginBottom: 2 },
  /** Employee name in header (left cluster with FY). */
  employeeTitle: {
    fontSize: 20,
    fontWeight: 500,
    color: "#111827",
    margin: 0,
    lineHeight: 1.3,
  },
  name: {
    fontSize: 20,
    fontWeight: 500,
    color: "#111827",
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
  /** Primary CTA: log activity — right side of header (purple accent, not muted). */
  headerLogRow: {
    border: "1.5px solid #a78bfa",
    borderRadius: 8,
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    marginLeft: "auto",
    flexShrink: 0,
    background: "#faf5ff",
    fontFamily: "inherit",
    textAlign: "left",
    boxShadow: "0 1px 3px rgba(91, 33, 182, 0.12)",
    transition: "background 0.15s, border-color 0.15s, box-shadow 0.15s",
  },
  yearTag: {
    display: "inline-block",
    fontSize: 11,
    background: "#f3f4f6",
    color: "#6b7280",
    borderRadius: 6,
    padding: "2px 8px",
    border: "0.5px solid #e5e7eb",
    fontWeight: 400,
  },
  yearSelect: {
    fontSize: 12,
    fontWeight: 500,
    color: "#374151",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "4px 10px",
    cursor: "pointer",
    fontFamily: "inherit",
    minWidth: "5.5rem",
  },
  heroGrid: {
    padding: "1.25rem 1.5rem",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: 12,
  },
  totalCard: {
    background: "#3C3489",
    borderRadius: 12,
    padding: "1.25rem",
    gridColumn: "span 3",
  },
  totalLabel: { fontSize: 12, color: "#AFA9EC", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 },
  totalValue: { fontSize: 36, fontWeight: 500, color: "#fff", lineHeight: 1 },
  totalValueSub: { fontSize: 16, color: "#AFA9EC", fontWeight: 400 },
  totalSub: { fontSize: 12, color: "#AFA9EC", marginTop: 6, marginBottom: 10 },
  progressTrack: { background: "rgba(255,255,255,0.15)", borderRadius: 99, height: 6 },
  progressFill: { height: 6, borderRadius: 99, background: "#CCC8F8" },
  metricCard: {
    background: "#f9fafb",
    borderRadius: 8,
    padding: "1rem 1.25rem",
  },
  metricLabel: { fontSize: 11, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 4 },
  metricValue: { fontSize: 24, fontWeight: 500, color: "#111827", lineHeight: 1 },
  metricSub: { fontSize: 11, color: "#6b7280", marginTop: 4 },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 500,
    color: "#9ca3af",
    padding: "0 1.5rem",
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  },
  activitiesList: {
    padding: "0 1.5rem 1.5rem",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  actRow: {
    background: "#fff",
    border: "0.5px solid #e5e7eb",
    borderRadius: 8,
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    transition: "background 0.12s",
  },
  actIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: 14,
  },
  actInfo: { flex: 1, minWidth: 0 },
  actName: { fontSize: 13, fontWeight: 500, color: "#111827", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
  actMeta: { fontSize: 11, color: "#6b7280", marginTop: 1 },
  actRight: { textAlign: "right", flexShrink: 0, alignSelf: "center" },
  actPts: { fontSize: 13, fontWeight: 500, color: "#111827", margin: 0 },
  resourcesBlock: {
    marginTop: 14,
    padding: "16px 14px",
    borderRadius: 12,
    background: "linear-gradient(135deg, #faf5ff 0%, #f5f3ff 55%, #eef2ff 100%)",
    border: "1px solid #ddd6fe",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    boxSizing: "border-box",
  },
  resourcesLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#6d28d9",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    margin: "0 0 2px",
  },
  resourceLink: {
    fontSize: 15,
    fontWeight: 600,
    color: "#4c1d95",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 14px",
    borderRadius: 10,
    background: "#fff",
    border: "1px solid #e9d5ff",
    boxShadow: "0 1px 2px rgba(91, 33, 182, 0.06)",
    transition: "border-color 0.15s, box-shadow 0.15s, background 0.15s",
    lineHeight: 1.35,
  },
  resourceLinkHover: {
    borderColor: "#c4b5fd",
    background: "#faf5ff",
    boxShadow: "0 2px 8px rgba(91, 33, 182, 0.12)",
  },
  resourceIconWrap: {
    width: 40,
    height: 40,
    borderRadius: 10,
    background: "#ede9fe",
    color: "#6d28d9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  resourceLinkText: {
    flex: 1,
    minWidth: 0,
  },
  resourceLinkSub: {
    display: "block",
    fontSize: 12,
    fontWeight: 500,
    color: "#7c3aed",
    marginTop: 2,
    opacity: 0.85,
  },
  addRow: {
    border: "0.5px dashed #d1d5db",
    borderRadius: 8,
    padding: "10px 14px",
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    opacity: 0.6,
  },
  footer: {
    fontSize: 11,
    color: "#9ca3af",
    padding: "0 1.5rem 1.5rem",
    lineHeight: 1.6,
  },
};
